import React from 'react';
import PublicLayout from '../components/Public/PublicLayout';
import RevealBlock from '../components/Public/RevealBlock';
import heroImage from '../assets/public/sections/home_hero_clean.jpg';
import mapImage from '../assets/public/sections/home_map_clean.jpg';
import '../styles/PublicSite.css';

const contactCards = [
  {
    id: 'telefono',
    title: 'Telefono',
    value: '4097-7396',
    href: 'tel:+50240977396',
    label: 'Llamar',
  },
  {
    id: 'correo',
    title: 'Correo',
    value: 'admims@maderasdelatlantico.com',
    href: 'mailto:admims@maderasdelatlantico.com',
    label: 'Escribir',
  },
  {
    id: 'ubicacion',
    title: 'Ubicacion',
    value: 'Km 12, ruta al Atlantico, entrada a Usumatlan, Zacapa.',
    href: 'https://maps.google.com/?q=Km+12+ruta+al+Atlantico+Usumatlan+Zacapa',
    label: 'Abrir mapa',
  },
];

const Contacto = () => {
  return (
    <PublicLayout>
      <div className="contact-page contact-page-modern">
        <section className="contact-hero">
          <img src={heroImage} alt="Maderas del Atlantico contacto" />
          <div className="contact-hero-overlay" />
          <div className="contact-hero-copy">
            <h1>Contacto</h1>
            <p>Estamos listos para atenderte de forma directa y agil.</p>
            <small>Para enviar cotizacion, usa el boton Cotizacion del encabezado.</small>
          </div>
        </section>

        <RevealBlock className="contact-main-grid" delay={80}>
          <article className="contact-info-panel">
            <h2>Informacion general</h2>
            <p>
              <span>Direccion:</span> Km 12, ruta al Atlantico, entrada a Usumatlan, Zacapa.
            </p>
            <p>
              <span>Telefono:</span> 4097-7396
            </p>
            <p>
              <span>Correo:</span> admims@maderasdelatlantico.com
            </p>

            <h3>Horario de atencion</h3>
            <ul>
              <li>Lunes a viernes: 7:00 a.m. - 4:00 p.m.</li>
              <li>Sabado: 7:00 a.m. - 11:00 a.m.</li>
              <li>Domingo: cerrado</li>
            </ul>
          </article>

          <figure className="contact-map-panel">
            <img src={mapImage} alt="Ubicacion de Maderas del Atlantico" />
            <a
              href="https://maps.google.com/?q=Km+12+ruta+al+Atlantico+Usumatlan+Zacapa"
              target="_blank"
              rel="noreferrer"
              className="public-outline-button"
            >
              Ver mapa <span aria-hidden="true">-></span>
            </a>
          </figure>
        </RevealBlock>

        <section className="contact-cards-grid">
          {contactCards.map((card, index) => (
            <RevealBlock key={card.id} className="contact-card-item" delay={110 + index * 90}>
              <h4>{card.title}</h4>
              <p>{card.value}</p>
              <a href={card.href} target={card.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
                {card.label}
              </a>
            </RevealBlock>
          ))}
        </section>
      </div>
    </PublicLayout>
  );
};

export default Contacto;
